import React, { useContext } from 'react'
import { Form, FormText, FormGroup, Input} from 'reactstrap'

export default function DepthSelector({ context }) {
  const { depth, setDepth } = useContext(context)

  return (
    <FormGroup>
      <label htmlFor="report" className="form-control-label">
        Posizioni SERP da scaricare
      </label>
      <div>
        <Input
          type="select"
          id="depth"
          value={depth}
          style={{width: '40%'}}
          onChange={e => setDepth(e.target.value)}
        >
          {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(d => <option value={d} key={d}>{d}</option>)}
        </Input>
      <FormText color="muted" align={'left'}>
        Seleziona il numero di risultati del foglio competitor.
      </FormText>
      </div>
    </FormGroup>
  )
}
